const { isEmpty, uniq } = require("lodash");
const { DateTime } = require("luxon");
const { fetchCollection, fetchDoc } = require("../firebase");

const { getClosedSchedule, generateSchedule } = require("./utils");
const shiftsByType = require("./shiftsByType");
const hydrateShift = require("./hydrate");
const { getAllTables } = require("../common/tables");

// function generateSchedule(business, shifts, allTables, type,) {
//   if (shifts.length === 0) return [];
//   return generateSchedule(business, shifts, allTables, type);
// }

function getSpecialOperatingDays(shift) {
  let operatingDays = [];
  let start = DateTime.fromJSDate(shift.startDate);
  const end = DateTime.fromJSDate(shift.endDate);
  if (shift?.specialType === "multiple-day-event") {
    while (start <= end) {
      operatingDays.push(start.weekdayLong);
      start = start.plus({ days: 1 });
    }
  } else {
    operatingDays.push(start.weekdayLong);
  }
  return uniq(operatingDays);
}

function combineSchedule(normalSchedule, specialSchedule) {
  const schedule = normalSchedule;
  if (isEmpty(specialSchedule)) return schedule;
  Object.entries(specialSchedule).forEach(([key, value]) => {
    // if (schedule[key]) {
    schedule[key] = value;
    // }
  });
  return schedule;
}

function getScheduleByShifts(
  business,
  shifts,
  date,
  allTables,
  withSpecialDay
) {
  let schedule = {};
  if (!isEmpty(shifts)) {
    let specialShifts = shiftsByType(shifts, date, "special-schedule");
    if (specialShifts.length > 0) {
      specialShifts = specialShifts.map((shift) => {
        return {
          ...shift,
          operatingDays: getSpecialOperatingDays(shift),
        };
      });
    }
    const normalShifts = shifts.filter(
      (shift) => shift.type === "normal-schedule"
    );
    const specialSchedule = generateSchedule(
      business,
      specialShifts,
      allTables,
      "special"
    );
    const normalSchedule = generateSchedule(
      business,
      normalShifts,
      allTables,
      "normal"
    );

    if (withSpecialDay) {
      schedule = combineSchedule(normalSchedule, specialSchedule);
    } else {
      schedule = normalSchedule;
    }
  }

  return schedule;
}

async function getSchedule(
  firebase,
  businessUid,
  selectedDate,
  withSpecialDay = true
) {
  const business = await fetchDoc(firebase, `/businesses/${businessUid}`);
  const allTables = await getAllTables(firebase, businessUid);
  const shifts = await fetchCollection(
    firebase,
    `shifts/business/${businessUid}`
  );
  const hydratedShift = shifts
    .map((shifts) => hydrateShift(shifts, firebase))
    .sort((a, b) => a.startTime - b.startTime);
  const day = DateTime.fromJSDate(selectedDate);
  const date = day.startOf("day").toJSDate();
  return getScheduleByShifts(
    business,
    hydratedShift,
    date,
    allTables,
    withSpecialDay
  );
}

module.exports = getSchedule;
